import styled from 'styled-components'

import { _L_Normal, mainColors } from '@avantstay/backoffice-core'

export const EmptyMessage = styled.p`
  ${_L_Normal};
  text-align: center;
  color: ${mainColors.neutralExtremelyDark};
  margin: 100px 0;
`
